import axios from "axios";

export function updateMessengerShiftStatusAction(bid, messengerId, isOnShift) {
    return {
        type: "UPDATE_MESSENGER_SHIFT_STATUS",
        meta: {
            bid: bid,
            messengerId: messengerId,
            isOnShift: isOnShift
        },
        payload: axios.post('/api/v2a/updateMessengerShiftStatus', {
            bid: bid,
            messengerId: messengerId,
            isOnShift: isOnShift
        })
    };
}

export function updateMessengerAvailabilityAction(bid, messengerId, isAvailable, isWhileMission = false) {
    return {
        type: "UPDATE_MESSENGER_AVAILABILITY",
        meta: {
            bid: bid,
            messengerId: messengerId,
            isAvailable: isAvailable,
            isWhileMission: isWhileMission
        },
        payload: axios.post('/api/v2a/updateMessengerAvailability', {
            bid: bid,
            messengerId: messengerId,
            isAvailable: isAvailable,
            isWhileMission: isWhileMission
        })
    };
}

export function updateMessengerAvailabilityUIAction(bid, messengerId, isAvailable, isWhileMission = false) {
    return {
        type: "UPDATE_MESSENGER_AVAILABILITY_UI",
        meta: {
            bid: bid,
            messengerId: messengerId,
            isAvailable: isAvailable,
            isWhileMission: isWhileMission
        }
    };
}